import { type ReactNode } from 'react';

interface ColorPaletteScaleProps {
    columnOneContent: ReactNode;
    columnTwoContent: ReactNode;
    columnThreeContent: ReactNode;
    columnFourContent: ReactNode;
    columnFiveContent: ReactNode;
}

export const ColorPaletteScale = ({
    columnOneContent,
    columnTwoContent,
    columnThreeContent,
    columnFourContent,
    columnFiveContent,
}: ColorPaletteScaleProps) => (
    <div className="sds_color-palette-scale__container">
        <div className="sds_color-palette-scale__container__column">{columnOneContent}</div>
        <div className="sds_color-palette-scale__container__column">{columnTwoContent}</div>
        <div className="sds_color-palette-scale__container__column">{columnThreeContent}</div>
        <div className="sds_color-palette-scale__container__column">{columnFourContent}</div>
        <div className="sds_color-palette-scale__container__column">{columnFiveContent}</div>
    </div>
);
